<script setup lang="ts">
import type { PropType } from 'vue';
import LoadingSpinner from '../icons/LoadingSpinner.vue';

const styles = {
  'gray': 'bg-gray-700 hover:bg-gray-600',
  'white': 'bg-white text-black hover:bg-gray-300',
  'full-width': 'w-full bg-gray-700 hover:bg-gray-600',
  'auto-width': 'w-auto hover:bg-gray-600',
  'custom-width': 'border border-gray-600 hover:bg-gray-600',
  'border': 'border border-gray-600 hover:bg-gray-600'
};

type Style = keyof typeof styles

const props = defineProps({
  types: {
    type: Array as PropType<Style[]>,
    default: [] as Style[]
  },
  customStyles: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  isLoading: {
    type: Boolean,
    default: false
  }
});

const getStyles = () => Array.isArray(props.types) && props.types?.length > 0 ? props.types?.map(type => {
  const style = styles[type as keyof typeof styles];
  if (style == null) return 'border border-gray-600 w-20 md:w-28';

  return style;
}).join(' ') : 'border border-gray-600 w-20 md:w-28 hover:bg-gray-600';
</script>

<template>
  <button
    class="inline-block px-4 py-1.5 transition-all rounded-md"
    :class="[customStyles, getStyles(), disabled && 'pointer-events-none border-gray-600 text-gray-500']"
  >
    <LoadingSpinner
      v-if="props.isLoading"
      class="w-5 h-5"
    />
    <slot v-else />
  </button>
</template>
